<gl-base-modal (closeModal)="close(false)">
  <h2 class="title">{{ 'warning' | translate }}</h2>
  <p class="info">{{ message | translate }}</p>
  <div class="buttons">
    <button outline-button (click)="close(true)">{{ 'yes' | translate }}</button>
    <button normal-outline-button (click)="close(false)">{{ 'no' | translate }}</button>
  </div>
</gl-base-modal>
